import React from 'react'
import classNames from 'classnames'
import s from './index.module.scss'

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'danger'
    type?: 'button' | 'submit' | 'reset'
    children: React.ReactNode
}

const Button: React.FC<Props> = ({ children, variant = 'primary', type, className, ...rest }) => {
    return (
        <button type={type} className={classNames(s.btn, s[variant], className)} {...rest}>
            {children}
        </button>
    )
}

export default Button
